import React, { useContext, useState } from 'react';
import 'antd/dist/antd.css';
import { Button, Input, Select } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import SL_Date from '../../components/dates/Date';
import { DateTime } from 'luxon';
import { displayMessage } from '../../services/helper';




export default function StatusFilters(props) {

    const [currentFilters, setCurrentFilters] = useState({})

    const {mobile_mode} = useContext(GeneralContext)



    const handleOnFilterChange = (type, value, parameterName) => {
        let currentFiltersUpdated = currentFilters

        if (type == 'date') {
            currentFiltersUpdated[parameterName] = value ? value.format('DD/MM/YYYY') : null
        }

        if (type == 'option') {
            currentFiltersUpdated[parameterName] = value
        }

        if (type == 'autocomplete') {
            currentFiltersUpdated[parameterName] = value
        }

        setCurrentFilters({ ...currentFiltersUpdated })
    }

    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    marginBottom: 15,
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>

                <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: mobile_mode ? 'center' : 'wrap', flex: 1, width: mobile_mode && '100%', alignItems: mobile_mode && 'center' }}>
                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: mobile_mode ? 'center' : 'wrap', flex: 1, width: mobile_mode && '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('DESCRIPTION')}:</div>
                                <Input
                                    style={{ width: 250 }}
                                    type="text"
                                    allowClear
                                    placeholder={displayMessage('SEARCH_PATIENT')}
                                    onChange={e => setCurrentFilters({ ...currentFilters, find: e.target.value })}
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, alignItems: mobile_mode && 'center', width: mobile_mode && '100%' }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('START_DATE')}:</div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={start_date => setCurrentFilters({ ...currentFilters, start_date: start_date?.format('YYYY-MM-DD') })}
                                    disabledDate={
                                        (current) => {
                                            return currentFilters.end_date ? current && current > DateTime.fromISO(currentFilters.end_date) : false

                                        }
                                    }
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, alignItems: mobile_mode && 'center', width: mobile_mode && '100%' }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('END_DATE')}:</div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={end_date => setCurrentFilters({ ...currentFilters, end_date: end_date?.format('YYYY-MM-DD') })}
                                    disabledDate={
                                        (current) => {
                                            return currentFilters.start_date ? current && current < DateTime.fromISO(currentFilters.start_date) : false
                                        }
                                    }
                                />
                            </div>

                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 5, alignItems: 'flex-end', marginTop: 10, padding: 5 }}>
                        <Button
                            onClick={() => props.handleOnSearchSatusHistory(currentFilters)}
                            type="primary"
                            style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                        >
                            {displayMessage('SEARCH')}
                        </Button>
                    </div>
                </div>
            </div>
        </div >


    )
}


